// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".businessManager{display:flex;flex-direction:column;height:100%;width:100%;overflow:hidden}.businessManagerEmptyState{display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:32px}.businessManagerBody{display:flex;flex:1;height:calc(100vh - 54px)}.businessManagerContent{width:100%}.businessManagerInner{position:relative;height:100%}\n", ""]);
// Exports
module.exports = exports;
